import { useEffect, useContext } from 'react'
import { appContext } from "../../AppContext";

export function useInitializeConfiguration(setIsloading) {

    const [appState, AppDispatch] = useContext(appContext);

    useEffect(() => {
        getConfiguration();

        async function getConfiguration() {
            fetch(`${process.env.PUBLIC_URL}/config.json`)
                .then((res) => {
                    res.json().then((json) => {

                        AppDispatch({ type: "INITIALIZECONFIG", payload: json })
                        setIsloading(false);
                    })
                })
        }
    // eslint-disable-next-line
    }, [])
    return [appState, AppDispatch]
}